import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Alert, AlertTitle, Typography } from '@mui/material';

type Props = {
  explanation: string;
};

export const CfiPrecedentBanner = ({ explanation }: Props) => (
  <Alert severity="warning" icon={<WarningAmberIcon />} sx={{ mb: 1 }}>
    <AlertTitle>Rubric / precedent conflict</AlertTitle>
    <Typography variant="body2">
      {explanation ||
        'The agent flagged a disagreement between the rubric and the consultant-precedent on this provision. Review carefully.'}
    </Typography>
  </Alert>
);
